
import { Component, Prop, Vue } from "vue-property-decorator";

const CLASS = "info-icon";

const ICONS = {
  information: "information-circle-outline",
};

@Component
export default class FlowCard extends Vue {
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;

  ICONS = ICONS;

  get classes() {
    const { disabled } = this;

    return {
      [`${CLASS}_disabled`]: disabled,
    };
  }
}
